export default __webpack_public_path__ + "static/media/eveningIcon.c9ed1eb7.svg";